// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3wS0C","rootCenter":"LoadMoreObserver_rootCenter__53F1W","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__LhG0U"};